import React, { useState } from 'react';
import { Phone, Mail, MapPin, AlertTriangle, ChevronDown, ChevronUp, Send } from 'lucide-react';
export function Contact() {
  const [activeFaq, setActiveFaq] = useState<number | null>(null);
  const faqs = [{
    q: 'Apakah cerita saya saat konseling akan dirahasiakan?',
    a: 'Tentu saja. Asas kerahasiaan adalah kode etik utama kami. Ceritamu tidak akan disebarkan kepada guru lain, teman, atau orang tua tanpa persetujuanmu, kecuali jika menyangkut keselamatan nyawa.'
  }, {
    q: 'Bagaimana cara mendaftar konseling?',
    a: "Kamu bisa mendaftar melalui menu 'Layanan', pilih jadwal yang tersedia, dan tentukan apakah ingin konseling online (chat) atau tatap muka di ruang BK."
  }, {
    q: 'Apakah saya boleh konseling hanya untuk curhat biasa?',
    a: 'Sangat boleh! BK bukan hanya untuk siswa yang bermasalah. Kamu bisa curhat tentang kebingungan memilih jurusan, masalah pertemanan, atau sekadar butuh teman ngobrol.'
  }, {
    q: 'Apakah layanan ini berbayar?',
    a: 'Tidak. Seluruh layanan Bimbingan dan Konseling di sekolah ini 100% gratis untuk seluruh siswa.'
  }];
  return <div className="bg-gray-50 min-h-screen py-12" data-id="element-215">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-216">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-217">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-218">
            Kontak & Bantuan
          </h1>
          <p className="text-gray-600 text-lg" data-id="element-219">
            Kami selalu siap mendengarkan. Hubungi kami jika kamu butuh bantuan
            atau memiliki pertanyaan.
          </p>
        </div>

        {/* Emergency Services - Prominent */}
        <div className="bg-red-50 border-2 border-red-200 rounded-3xl p-8 mb-12 shadow-sm" data-id="element-220">
          <div className="flex items-center gap-3 mb-6" data-id="element-221">
            <AlertTriangle className="text-red-500" size={32} data-id="element-222" />
            <h2 className="text-2xl font-bold text-red-700" data-id="element-223">
              Layanan Darurat 24 Jam
            </h2>
          </div>
          <p className="text-red-600 mb-6 font-medium" data-id="element-224">
            Jika kamu merasa dalam bahaya, memiliki pemikiran untuk menyakiti
            diri sendiri, atau membutuhkan bantuan medis/psikologis segera,
            hubungi layanan profesional berikut:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-225">
            <div className="bg-white p-4 rounded-xl border border-red-100 shadow-sm" data-id="element-226">
              <h4 className="font-bold text-gray-800 mb-1" data-id="element-227">
                Into The Light Indonesia
              </h4>
              <p className="text-red-600 font-bold text-lg" data-id="element-228">119 ext 8</p>
            </div>
            <div className="bg-white p-4 rounded-xl border border-red-100 shadow-sm" data-id="element-229">
              <h4 className="font-bold text-gray-800 mb-1" data-id="element-230">Sejiwa (Yayasan)</h4>
              <p className="text-red-600 font-bold text-lg" data-id="element-231">021-9696 9293</p>
            </div>
            <div className="bg-white p-4 rounded-xl border border-red-100 shadow-sm" data-id="element-232">
              <h4 className="font-bold text-gray-800 mb-1" data-id="element-233">
                LSM Jangan Bunuh Diri
              </h4>
              <p className="text-red-600 font-bold text-lg" data-id="element-234">0858-9113-8787</p>
            </div>
            <div className="bg-white p-4 rounded-xl border border-red-100 shadow-sm" data-id="element-235">
              <h4 className="font-bold text-gray-800 mb-1" data-id="element-236">Hotline Kemenkes</h4>
              <p className="text-red-600 font-bold text-lg" data-id="element-237">500-454</p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16" data-id="element-238">
          {/* Contact Info & Form */}
          <div data-id="element-239">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-240">
              Hubungi Ruang BK
            </h3>
            <div className="space-y-6 mb-8" data-id="element-241">
              <div className="flex items-start gap-4" data-id="element-242">
                <div className="p-3 bg-primary-light/20 text-primary-dark rounded-xl" data-id="element-243">
                  <Phone size={24} data-id="element-244" />
                </div>
                <div data-id="element-245">
                  <h4 className="font-bold text-gray-800" data-id="element-246">WhatsApp Admin BK</h4>
                  <p className="text-gray-600" data-id="element-247">
                    0812-3456-7890 (Senin - Jumat, 08:00 - 15:00)
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-248">
                <div className="p-3 bg-primary-light/20 text-primary-dark rounded-xl" data-id="element-249">
                  <Mail size={24} data-id="element-250" />
                </div>
                <div data-id="element-251">
                  <h4 className="font-bold text-gray-800" data-id="element-252">Email</h4>
                  <p className="text-gray-600" data-id="element-253">bk@sekolahkita.sch.id</p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-254">
                <div className="p-3 bg-primary-light/20 text-primary-dark rounded-xl" data-id="element-255">
                  <MapPin size={24} data-id="element-256" />
                </div>
                <div data-id="element-257">
                  <h4 className="font-bold text-gray-800" data-id="element-258">Lokasi</h4>
                  <p className="text-gray-600" data-id="element-259">
                    Gedung Utama Lantai 1, Ruang Bimbingan & Konseling
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100" data-id="element-260">
              <h4 className="font-bold text-gray-800 mb-4" data-id="element-261">
                Kirim Pesan Cepat
              </h4>
              <form className="space-y-4" data-id="element-262">
                <input type="text" placeholder="Nama Lengkap" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary outline-none" data-id="element-263" />
                <input type="email" placeholder="Email / No. HP" className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary outline-none" data-id="element-264" />
                <textarea rows={4} placeholder="Pesanmu..." className="w-full px-4 py-3 rounded-xl border border-gray-200 focus:ring-2 focus:ring-primary outline-none resize-none" data-id="element-265"></textarea>
                <button type="button" className="w-full bg-primary text-white py-3 rounded-xl font-bold flex justify-center items-center gap-2 hover:bg-primary-dark transition-colors" data-id="element-266">
                  Kirim Pesan <Send size={18} data-id="element-267" />
                </button>
              </form>
            </div>
          </div>

          {/* FAQ */}
          <div data-id="element-268">
            <h3 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-269">
              Pertanyaan Sering Diajukan (FAQ)
            </h3>
            <div className="space-y-4" data-id="element-270">
              {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-2xl overflow-hidden" data-id="element-271">
                  <button onClick={() => setActiveFaq(activeFaq === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-272">
                    <span className="font-bold text-gray-800" data-id="element-273">{faq.q}</span>
                    {activeFaq === index ? <ChevronUp className="text-primary" data-id="element-274" /> : <ChevronDown className="text-gray-400" data-id="element-275" />}
                  </button>
                  {activeFaq === index && <div className="px-6 pb-4 text-gray-600" data-id="element-276">
                      <div className="w-full h-px bg-gray-100 mb-4" data-id="element-277"></div>
                      {faq.a}
                    </div>}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
}